module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-widget"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "current-tags"
  }, [_vm._l((_vm.pickedTags), function(tag) {
    return _c('span', {
      staticClass: "label label-info"
    }, [_vm._v(_vm._s(tag.name) + " "), (!_vm.readOnly) ? _c('button', {
      on: {
        "click": function($event) {
          return _vm.removeTag(tag.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })]) : _vm._e()])
  }), _vm._v(" "), (!_vm.tags.length && _vm.renderEmpty) ? _c('span', [_c('i', [_vm._v("no tags")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('div', {
    staticClass: "dropdown",
    class: {
      open: _vm.showTagsMenu
    }
  }, [_c('span', {
    staticClass: "label label-add"
  }, [_c('button', {
    staticClass: "dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.showTagsMenu = !_vm.showTagsMenu
      }
    }
  }, [(!_vm.showTagsMenu) ? _c('i', {
    staticClass: "fa fa-lg fa-plus"
  }) : _c('i', {
    staticClass: "fa fa-lg fa-close"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('FormulateInput', {
    attrs: {
      "type": "search",
      "error": _vm.searchError
    },
    on: {
      "input": _vm.fetchTags
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', {
    staticClass: "pre-scrollable"
  }, [(_vm.availableTags.length) ? _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.availableTags), function(tagOption) {
    return _c('li', {
      key: tagOption.id
    }, [_c('a', {
      staticClass: "label label-info",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addTag(tagOption)
        }
      }
    }, [_vm._v(_vm._s(tagOption.name))])])
  }), 0) : _c('div', [_c('i', [_vm._v("empty")])])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('FormulateInput', {
    attrs: {
      "disabled": !_vm.query,
      "type": "button"
    },
    on: {
      "click": _vm.createTag
    }
  }, [_vm._v("Create "), (_vm.query) ? _c('span', [_vm._v(" \"" + _vm._s(_vm.query) + "\" tag")]) : _vm._e()])], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-147b8bd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/TagsWidget.vue
// module id = 612
// module chunks = 0